import styled from 'styled-components';

import { SvgIcon } from '@telialt/common-icon/src';
import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

export const ModalWrapper = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
`;
export const SideImgCol = styled.div`
    display: none;
    width: 18.75rem;
    overflow: hidden;

    ${purpurMedia('lg')`
        display: block;
    `};

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;
export const ContentCol = styled.div`
    flex: 1;
    position: relative;
`;
export const CloseContainer = styled.div`
    position: absolute;
    right: 2.2rem;
    top: 0.7rem;
    z-index: 100;
`;
export const CloseIcon = styled(SvgIcon)`
    font-size: 2rem;
    fill: currentColor;
    height: 1em;
    width: 1em;
`;
export const ModalContent = styled.div`
    position: relative;
    z-index: 50;
    padding-top: ${getPurpurSpacing('600')};
    padding-bottom: ${getPurpurSpacing('300')};
    padding-left: ${getPurpurSpacing('400')};
    padding-right: ${getPurpurSpacing('400')};
    overflow-y: auto;
    overflow-x: hidden;
    height: 100%;
    display: flex;
    flex-direction: column;

    ${purpurMedia('lg')`
        padding-left: ${getPurpurSpacing('600')};
        padding-right: ${getPurpurSpacing('600')};
        padding-top: ${getPurpurSpacing('300')};
    `};
`;
